import React, { useState } from "react";

import { Alert, Button, Col, Form, Input, Row } from "antd";
import { API_BASE_URL, CREATE_CITY, directToken } from "../services/end_points";
import { _post } from "../services/service_api";
const AddCity = ({ updateUserList }) => {
  const [alert, setAlert] = useState(false);
  const [formdata, setFormdata] = useState({ city: "" });
  const [success, setSuccess] = useState(false);
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleReset = () => {
    setFormdata({ city: "" });
  };
  const handleCity = async (e) => {
    e.preventDefault();
    try {
      const response = await _post(
        `${API_BASE_URL}${CREATE_CITY}`,
        formdata,
        directToken
      );
      setFormdata({ city: "" });
      if (response.status == 201) {
        setAlert(true);

        setTimeout(() => {
          setAlert(false);
        }, 2000);
        updateUserList(response.data);
      }
    } catch (err) {
      console.error(err);
      setAlert(false);
      setSuccess(false);
    }
  };

  return (
    <>
      <Row>
        <Form onFinish={handleCity} layout="vertical">
          <div>
            <div>
              {alert && (
                <div>
                  <Alert
                    type="success"
                    style={{
                      backgroundColor: "#dbffb8cf",
                      color: "black",
                      width: "100%",
                      marginTop: "0.5rem",
                      marginBottom: "2rem",
                    }}
                    message={"City Created!"}
                  />
                </div>
              )}
            </div>
            {!success && (
              <>
                <Col
                  md={20}
                  xl={24}
                  lg={24}
                  sm={24}
                  style={{
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Form.Item label="Add City Name" required>
                    <Input
                      id="city"
                      name="city"
                      value={formdata.city}
                      onChange={handleFormChange}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: "1rem", // Adjust spacing as needed
                      width: "20vw",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={handleReset}
                      style={{
                        color: "black",
                        // border: "solid #6c757d ",
                        // backgroundColor: "    ",
                        border: "solid #fd6f6f",
                        marginRight: "auto",
                        width: "85px",
                        height: "32px",
                        borderRadius: "3vw",
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      onClick={handleCity}
                      style={{
                        // color: "black",
                        color: "white",
                        // background: "#1236fa",
                        // background: "#D5006D",
                        // background: "#ff6682c2",
                        // background: "#007bff ",
                        background: "#28a745 ",
                        // background: "#1bbf41",
                        width: "85px",
                        height: "32px",
                        borderRadius: "3vw",
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </Col>
              </>
            )}
          </div>
        </Form>
      </Row>
    </>
  );
};
export default AddCity;
